import { render, staticRenderFns } from "./ChargeWallet.vue?vue&type=template&id=6ba8ee62&scoped=true"
import script from "./ChargeWallet.vue?vue&type=script&lang=js"
export * from "./ChargeWallet.vue?vue&type=script&lang=js"
import style0 from "./ChargeWallet.vue?vue&type=style&index=0&id=6ba8ee62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8ee62",
  null
  
)

export default component.exports